<template>
    <div v-if="consultation.anonym" class="u-card__intro">
        <img :src="anonymImg" class="u-card__photo avatar" alt>

        <span class="u-card__name">Аноним</span>
    </div>
    <div v-else class="u-card__intro">
        <template v-if="!consultation.patient.user.deleted_at">
            <a :href="url">
                <img :src="avatar" class="u-card__photo avatar" alt>
            </a>

            <a :href="url">
                <span class="u-card__name" v-html="name"></span>
            </a>
        </template>
        <template v-else>
            <img :src="avatar" class="u-card__photo avatar" alt>

            <span class="u-card__name" v-html="name"></span>
        </template>
    </div>
</template>

<script>
    import dayjs from "dayjs";
    import utc from 'dayjs/plugin/utc';
    import api from "../../../../admin/api/api";

    dayjs.extend(utc);

    export default {
        name: "CardDoctor",
        props: {
            consultation: {
                type: Object,
                required: true
            },
        },
        data() {
            return {
                anonymImg: window.laravel.anonymImg
            }
        },
        computed: {
            avatar() {
                return this.consultation.family ? this.consultation.family.photo : this.consultation.patient.user.avatar;
            },
            url() {
                return this.consultation.family ? '/family/' + this.consultation.family.slug : '/patient/' + this.consultation.patient.id;
            },
            name() {
                return this.consultation.family ? this.consultation.family.name : this.consultation.patient.user.name;
            }
        }
    }
</script>
